'use client';

import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';
import { SheetClose } from '@/components/ui/sheet';

interface CartDrawerHeaderProps {
  itemCount: number;
}

export function CartDrawerHeader({ itemCount }: CartDrawerHeaderProps) {
  return (
    <header className="flex items-center justify-between gap-2 px-6 pt-5 pb-4">
      <div className="flex items-center gap-2">
        <h2
          className="text-2xl leading-8 font-bold text-gray-900"
          data-testid={DataTestIdEnum.CART_DRAWER_TITLE}
        >
          Carrinho
        </h2>

        {itemCount > 0 && (
          <span
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-success-100 text-sm font-bold text-green-500"
            data-testid={DataTestIdEnum.CART_DRAWER_COUNT_BADGE}
          >
            {itemCount}
          </span>
        )}
      </div>

      <SheetClose
        aria-label="Fechar carrinho"
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-sm text-gray-500 transition-opacity hover:opacity-70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500"
        data-testid={DataTestIdEnum.CART_DRAWER_CLOSE_BUTTON}
      >
        <Icon icon={faXmark} className="h-5 w-5" />
      </SheetClose>
    </header>
  );
}
